import LocalGroupMemberDetailsForm from './LocalGroupMemberDetailsForm';

export * from './types';

export default LocalGroupMemberDetailsForm;
